import * as yup from 'yup'

import {camelCaseToString} from '.'

const validations = {
	getPasswordValidator: (name = 'password') =>
		yup
			.string()
			.min(6, `${name} must contain at least 6 characters`)
			.matches(/^(?!.* ).{6,}$/, `${name} must not contain spaces`)
			.required(`${name} field is required`),
	getURLValidator: (name = 'URL') =>
		yup
			.string()
			.notRequired()
			.matches(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/, {
				message: `${name} must be valid URL`,
				excludeEmptyString: true,
			}),
}

type TMessageFunc = (p: {path: string; label: string}) => string

function _createMessagesMap<T extends {[name: string]: TMessageFunc}>(cfg: T) {
	return cfg
}

export const messages = _createMessagesMap({
	required: ({path, label}) =>
		`${camelCaseToString((path || label) as string)} should not be empty`,
})

export default validations
